module.exports = __webpack_public_path__ + "media/images/emblems/Vulliens-coat_of_arms-27111b678432f866d66e8233ee616567.svg";